// extracted by mini-css-extract-plugin
export default {"mainWrapper":"InquiryContactInfo_mainWrapper__CTOox"};